<template>
  <div class="dropdown" v-bind:class="{ disabled: !$slots.default }">
    <button data-label="Ações" class="hint hint--left btn dropbtn" :disabled="!$slots.default" @click="openDropdown()">
      <i class="dropbtn fa fa-ellipsis-v"></i>
    </button>
    <div :id="identifier" class="dropdown-content">
      <ul>
        <slot/>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      identifier: {
        type: String,
        required: true
      }
    },
    mounted () {
      const closeAll = this.closeAll
      window.onclick = function (event) {
        if (!event.target.matches('.dropbtn')) {
          closeAll()
        }
      }
    },
    methods: {
      closeAll (keepCurrent) {
        const dropdowns = document.getElementsByClassName('dropdown-content')

        for (let i = 0; i < dropdowns.length; i++) {
          const openDropdown = dropdowns[i]

          if (keepCurrent && openDropdown.id === this.identifier) {
            continue
          }

          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show')
          }
        }
      },
      openDropdown () {
        this.closeAll(true)
        document.getElementById(this.identifier).classList.toggle('show')
      }
    }
  }
</script>

<style scoped lang="sass">
  i
    color: #7872ff

  ul
    list-style: none
    margin: 0
    padding: 4px 0

  .dropbtn
    margin-left: 10px
    font-size: 24px
    padding: 0

  button.dropbtn
    cursor: pointer

    &[disabled]
      cursor: not-allowed

  .dropdown
    position: relative
    display: inline-block
    vertical-align: middle

    &.disabled
      cursor: not-allowed

      i
        opacity: 0.3

  .dropdown-content
    display: none
    position: absolute
    background-color: #fff
    min-width: 180px
    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.08)
    font-size: 14px
    color: #333333
    border: 1px solid #ddd
    border-radius: 3px
    cursor: pointer
    padding: 4px 0
    margin-top: 4px
    right: 0
    z-index: 2147483647

    li
      display: block
      padding: 0 4px

      &:not(:last-child)
        margin-bottom: 2px

    span, a
      color: #333333
      text-decoration: none
      display: block
      border-radius: 3px
      padding: 6px 12px

      &.is-active
        background-color: #7872ff
        color: #fff

      &:not(.is-active):hover
        background-color: #f2f2f2

  .show
    display: block
</style>



// WEBPACK FOOTER //
// ButtonActions.vue?1217e455